import { BNBChain, BerachainbArtio, Ethereum, Merlin, SeiTestnet } from '@particle-network/chains';
export var RPC_METHOD;
(function (RPC_METHOD) {
    RPC_METHOD["AIRDROP"] = "enhancedAirdrop";
    RPC_METHOD["GET_ACCOUNT_INFO"] = "getAccountInfo";
    RPC_METHOD["NFT_INITIALIZE_STORE"] = "NFT_initializeStore";
    RPC_METHOD["NFT_CHECK_STORE_HAS_INITIALIZED"] = "NFT_checkStoreHasInitialized";
    RPC_METHOD["NFT_CHECK_STORE_CREATOR_IS_ACTIVATED"] = "NFT_checkStoreCreatorIsActivated";
    RPC_METHOD["NFT_SET_WHITE_LISTED_CREATOR"] = "NFT_setWhitelistedCreator";
    RPC_METHOD["NFT_MINT"] = "NFT_mint";
    RPC_METHOD["NFT_UPDATE"] = "NFT_update";
    RPC_METHOD["NFT_LIST"] = "NFT_list";
    RPC_METHOD["NFT_UNLIST"] = "NFT_unlist";
    RPC_METHOD["NFT_SETTLE"] = "NFT_settle";
    RPC_METHOD["NFT_WITHDRAW"] = "NFT_withdraw";
    RPC_METHOD["NFT_BUY"] = "NFT_buy";
    RPC_METHOD["SEND_AND_CONFIRM_RAW_TRANSACTION"] = "enhancedSendAndConfirmRawTransaction";
    RPC_METHOD["GET_TOKENS_AND_NFTS"] = "enhancedGetTokensAndNFTs";
})(RPC_METHOD || (RPC_METHOD = {}));
/**
 * 交易类型
 * value 小写
 */
export var TransactionsType;
(function (TransactionsType) {
    TransactionsType["RSS3_NATIVE_SEND"] = "rss3_native_send";
    TransactionsType["RSS3_NATIVE_RECEIVE"] = "rss3_native_receive";
    TransactionsType["NATIVE_SEND"] = "native_send";
    TransactionsType["NATIVE_RECEIVE"] = "native_receive";
    TransactionsType["RSS3_TOKEN_SEND"] = "rss3_token_send";
    TransactionsType["TOKEN_SEND"] = "token_send";
    TransactionsType["RSS3_TOKEN_RECEIVE"] = "rss3_token_receive";
    TransactionsType["RSS3_ERC_20_APPROVE"] = "rss3_erc_20_approve";
    TransactionsType["RSS3_ERC_20_BURN"] = "rss3_erc_20_burn";
    TransactionsType["RSS3_NFT_SEND"] = "rss3_nft_send";
    TransactionsType["RSS3_NFT_RECEIVE"] = "rss3_nft_receive";
    TransactionsType["RSS3_NFT_APPROVE"] = "rss3_nft_approve";
    TransactionsType["RSS3_NFT_MINT"] = "rss3_nft_mint";
    TransactionsType["RSS3_NFT_BUY"] = "rss3_nft_buy";
    TransactionsType["RSS3_SWAP"] = "rss3_swap";
    TransactionsType["CHECK_IN"] = "check_in";
    TransactionsType["OTHER"] = "other";
    TransactionsType["UNKNOWN"] = "unknown";
})(TransactionsType || (TransactionsType = {}));
export var AccountAbstractionType;
(function (AccountAbstractionType) {
    AccountAbstractionType["BICONOMY"] = "BICONOMY";
    AccountAbstractionType["CYBERCONNECT"] = "CYBERCONNECT";
    AccountAbstractionType["SIMPLE"] = "SIMPLE";
    AccountAbstractionType["LIGHT"] = "LIGHT";
    AccountAbstractionType["BTC"] = "BTC";
    AccountAbstractionType["UNIVERSAL"] = "UNIVERSAL";
    AccountAbstractionType["XTERIO"] = "XTERIO";
})(AccountAbstractionType || (AccountAbstractionType = {}));
export var TransactionType;
(function (TransactionType) {
    /**
     * transfer
     */
    TransactionType["TRANSFER"] = "TRANSFER";
    /**
     * NFT
     */
    TransactionType["NFT"] = "NFT";
    /**
     * SWAP
     */
    TransactionType["SWAP"] = "SWAP";
    /**
     * BRIDGE
     */
    TransactionType["BRIDGE"] = "BRIDGE";
    /**
     * BATCH_TRANSFER
     */
    TransactionType["BATCH_TRANSFER"] = "BATCH_TRANSFER";
    /**
     * BATCH_NFT
     */
    TransactionType["BATCH_NFT"] = "BATCH_NFT";
    /**
     * upgrade account
     */
    TransactionType["UPGRADE_ACCOUNT"] = "UPGRADE_ACCOUNT";
})(TransactionType || (TransactionType = {}));
export var CROSS_USER_OPERATION_STATUS;
(function (CROSS_USER_OPERATION_STATUS) {
    CROSS_USER_OPERATION_STATUS[CROSS_USER_OPERATION_STATUS["LOCAL"] = 0] = "LOCAL";
    CROSS_USER_OPERATION_STATUS[CROSS_USER_OPERATION_STATUS["PARTICLE_SEND_FAILED"] = 1] = "PARTICLE_SEND_FAILED";
    CROSS_USER_OPERATION_STATUS[CROSS_USER_OPERATION_STATUS["TARGET_SEND_FAILED"] = 2] = "TARGET_SEND_FAILED";
    CROSS_USER_OPERATION_STATUS[CROSS_USER_OPERATION_STATUS["PENDING"] = 3] = "PENDING";
    CROSS_USER_OPERATION_STATUS[CROSS_USER_OPERATION_STATUS["WAIT_TO_REFUND"] = 4] = "WAIT_TO_REFUND";
    CROSS_USER_OPERATION_STATUS[CROSS_USER_OPERATION_STATUS["REFUND"] = 5] = "REFUND";
})(CROSS_USER_OPERATION_STATUS || (CROSS_USER_OPERATION_STATUS = {}));
export var CROSS_USER_OPERATION_CHAIN_STATUS;
(function (CROSS_USER_OPERATION_CHAIN_STATUS) {
    CROSS_USER_OPERATION_CHAIN_STATUS[CROSS_USER_OPERATION_CHAIN_STATUS["LOCAL"] = 0] = "LOCAL";
    CROSS_USER_OPERATION_CHAIN_STATUS[CROSS_USER_OPERATION_CHAIN_STATUS["SEND_SUCCESS"] = 1] = "SEND_SUCCESS";
    CROSS_USER_OPERATION_CHAIN_STATUS[CROSS_USER_OPERATION_CHAIN_STATUS["SEND_FAILED"] = 2] = "SEND_FAILED";
    CROSS_USER_OPERATION_CHAIN_STATUS[CROSS_USER_OPERATION_CHAIN_STATUS["CHAIN_SUCCESS"] = 3] = "CHAIN_SUCCESS";
    CROSS_USER_OPERATION_CHAIN_STATUS[CROSS_USER_OPERATION_CHAIN_STATUS["CHAIN_FAILED"] = 4] = "CHAIN_FAILED";
})(CROSS_USER_OPERATION_CHAIN_STATUS || (CROSS_USER_OPERATION_CHAIN_STATUS = {}));
export const TokenIcon = {
    ETH: Ethereum.icon,
    BNB: BNBChain.icon,
    BTC: Merlin.nativeIcon || '',
    SEI: SeiTestnet.icon,
    BERA: BerachainbArtio.icon,
    USDC: 'https://static.particle.network/token-list/ethereum/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48.png',
    USDT: 'https://static.particle.network/token-list/ethereum/0xdAC17F958D2ee523a2206206994597C13D831ec7.png',
    USDG: 'https://wallet-debug.particle.network/ug.png',
};
/**
 * https://minijoy.feishu.cn/docx/MkdTdRqBwo7ds2xKD4UcTDsInWh#PA09df7H8oZGYyxP0BbcIPaZnch
 */
export var SUPPORTED_TOKEN_TYPE;
(function (SUPPORTED_TOKEN_TYPE) {
    SUPPORTED_TOKEN_TYPE["ETH"] = "eth";
    SUPPORTED_TOKEN_TYPE["USDT"] = "usdt";
    SUPPORTED_TOKEN_TYPE["USDC"] = "usdc";
    SUPPORTED_TOKEN_TYPE["USDG"] = "usdg";
    SUPPORTED_TOKEN_TYPE["BNB"] = "bnb";
    SUPPORTED_TOKEN_TYPE["BTC"] = "btc";
    SUPPORTED_TOKEN_TYPE["SEI"] = "sei";
    SUPPORTED_TOKEN_TYPE["BERA"] = "bera";
})(SUPPORTED_TOKEN_TYPE || (SUPPORTED_TOKEN_TYPE = {}));
export var TOKENLIst_SUPPORTED_TOKEN_TYPE;
(function (TOKENLIst_SUPPORTED_TOKEN_TYPE) {
    TOKENLIst_SUPPORTED_TOKEN_TYPE["ETH"] = "eth";
    TOKENLIst_SUPPORTED_TOKEN_TYPE["USDC"] = "usdc";
    TOKENLIst_SUPPORTED_TOKEN_TYPE["USDG"] = "usdg";
    // BNB = 'bnb',
    // BTC = 'btc',
})(TOKENLIst_SUPPORTED_TOKEN_TYPE || (TOKENLIst_SUPPORTED_TOKEN_TYPE = {}));
/**
 * https://minijoy.feishu.cn/docx/MkdTdRqBwo7ds2xKD4UcTDsInWh#WtkvdfoHboINJExqrHocZIOgntg
 *     3 6 8 9 10  11 14前端显示失败的状态
 *     7 显示成功的状态
 *     其他显示pending状态
 */
export var CROSS_USER_OPERATION_V2_STATUS;
(function (CROSS_USER_OPERATION_V2_STATUS) {
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["INITIALIZING"] = 0] = "INITIALIZING";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["DEPOSIT_LOCAL"] = 1] = "DEPOSIT_LOCAL";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["DEPOSIT_PENDING"] = 2] = "DEPOSIT_PENDING";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["DEPOSIT_FAILED"] = 3] = "DEPOSIT_FAILED";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["EXECUTION_LOCAL"] = 4] = "EXECUTION_LOCAL";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["EXECUTION_PENDING"] = 5] = "EXECUTION_PENDING";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["EXECUTION_FAILED"] = 6] = "EXECUTION_FAILED";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["FINISHED"] = 7] = "FINISHED";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["REFUND_PENDING"] = 8] = "REFUND_PENDING";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["REFUND_SUCCESS"] = 9] = "REFUND_SUCCESS";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["REFUND_FAILED"] = 10] = "REFUND_FAILED";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["REFUND_FINISHED"] = 11] = "REFUND_FINISHED";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["PENNY_LOCAL"] = 12] = "PENNY_LOCAL";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["PENNY_PENDING"] = 13] = "PENNY_PENDING";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["PENNY_FAILED"] = 14] = "PENNY_FAILED";
    CROSS_USER_OPERATION_V2_STATUS[CROSS_USER_OPERATION_V2_STATUS["PENNY_FINISHED"] = 15] = "PENNY_FINISHED";
})(CROSS_USER_OPERATION_V2_STATUS || (CROSS_USER_OPERATION_V2_STATUS = {}));
//# sourceMappingURL=types.js.map